import { ENVIRONMENTS } from 'shared/utils/environment/types';
import { getEnvironment } from 'shared/utils/environment/determineEnvironment';

export const debugLog = (...args: any[]): void => {
  if (getEnvironment() !== ENVIRONMENTS.PRODUCTION) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};
